import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Cuestionario from '@/components/Cuestionario'
import Resultados from '@/components/Resultados'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/cuestionario',
      name: 'Cuestionario',
      component: Cuestionario
    },
    {
      path: '/resultados',
      name: 'Resultados',
      component: Resultados
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js